module.exports = {
  "zones": {
    "Pacific/Kiritimati": ["z", {
      "wallclock": 788832000000,
      "format": "+14",
      "abbrev": "+14",
      "offset": 50400000,
      "posix": 788868000000,
      "save": 0
    }, {
      "wallclock": 307584000000,
      "format": "-10",
      "abbrev": "-10",
      "offset": -36000000,
      "posix": 307622400000,
      "save": 0
    }, {
      "wallclock": -2177452800000,
      "format": "-1040",
      "abbrev": "-1040",
      "offset": -38400000,
      "posix": -2177415040000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -37760000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {}
};